import React, { Component } from "react";
import man from "../../../assets/images/dashboard/user2.jpg";
import { connect } from "react-redux";

export class User_panel extends Component {
  render() {
    const { currentAdmin } = this.props;
    return (
      <div className="sb-user-card">
        <span className="sb-user-avatar">
          {currentAdmin && currentAdmin.image ? (
            <img src={currentAdmin.image} alt={currentAdmin.name} />
          ) : (
            <img src={man} alt="user" />
          )}
        </span>
        <div className="sb-user-info">
          <p className="sb-user-name">{currentAdmin ? currentAdmin.name : ""}</p>
          {currentAdmin && currentAdmin.status && (
            <span className="sb-user-role">{currentAdmin.status}</span>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentAdmin: state.admins.currentAdmin,
});

export default connect(mapStateToProps, null)(User_panel);
